<template>
  <v-container>
    <div style="overflow-y: auto; max-height: 60vh; padding-bottom: 0.1vh">
      <div
        class="status-row"
        no-gutters
        style="white-space: nowrap; display: flex"
      >
        <!-- ステータス部分 + drop機能追加 -->
        <v-col
          v-for="(status, statusKey) in filteredStatus"
          :key="statusKey"
          cols="12"
          md="4"
          style="display: inline-block; flex: 0 0 auto; width: 300px"
          @dragover.prevent="onDragOver($event)"
          @dragenter="handleDragEnter(statusKey)"
          @dragleave="handleDragLeave(statusKey)"
          @drop="onDrop(statusKey, status)"
        >
          <v-card class="status-column" outlined>
            <!-- ステータス名部分 -->
            <!-- @contextmenu.prevent="
              rightClickMenu($event, status.selectionData, statusKey)
            " -->
            <v-card-title class="status-title">
              <div class="title-container">
                <span class="status-label">{{ status.selectionData }}</span>

                <v-menu offset-y>
                  <template #activator="{ props }">
                    <v-btn
                      icon
                      v-bind="props"
                      density="compact"
                      rounded="lg"
                      variant="text"
                      class="status-menu-btn"
                    >
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      @click="openRenameDialog(status.selectionData, statusKey)"
                    >
                      <v-list-item-title>名前変更</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      @click="openDeleteDialog(status.selectionData, statusKey)"
                    >
                      <v-list-item-title>削除</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </v-card-title>

            <v-menu
              v-model="contextMenuVisible"
              :style="{
                position: 'absolute',
                top: `${rightClickPosition.y}px`,
                left: `${rightClickPosition.x}px`,
              }"
            >
              <v-list>
                <v-list-item @click="openRenameDialog">名前変更</v-list-item>
                <v-list-item @click="openDeleteDialog">削除</v-list-item>
              </v-list>
            </v-menu>

            <!-- 名前変更ダイアログ -->
            <v-dialog v-model="renameDialogVisible" max-width="400px">
              <v-card>
                <v-card-title>名前変更</v-card-title>
                <v-card-text>
                  <v-text-field
                    label="新しい名前"
                    v-model="newStatusName"
                    outlined
                  ></v-text-field>
                </v-card-text>
                <v-card-actions>
                  <v-btn text @click="renameDialogVisible = false"
                    >キャンセル</v-btn
                  >
                  <v-btn color="primary" @click="selectionDataEdit()"
                    >保存</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>

            <!-- 削除確認ダイアログ -->
            <v-dialog v-model="confirmDeleteDialogVisible" max-width="400px">
              <v-card>
                <v-card-title>削除確認</v-card-title>
                <v-card-text>
                  本当に "{{ selectedStatusName }}" を削除しますか?
                </v-card-text>
                <v-card-actions>
                  <v-btn text @click="confirmDeleteDialogVisible = false"
                    >キャンセル</v-btn
                  >
                  <v-btn color="red" @click="deleteData()">削除</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-card-text>
              <!-- 新規カード追加ボタン -->
              <v-btn
                block
                class="new-card-btn"
                @click="openNewCardDialog(status.propertyId, status.dataValue)"
              >
                新規カード追加+
              </v-btn>

              <br />
              <!-- カード部分 + dragの機能追加 -->
              <div v-if="status.cards && status.cards.length > 0">
                <!-- カードの表示 -->
                <div
                  v-for="(card, cardIndex) in status.cards
                    .filter(card => card.cardId !== null && card.isDeleted == 0)"
                  :key="cardIndex"
                  elevation="2"
                  @contextmenu.prevent="showContextMenu($event, card)"
                  @click.stop="openSidebar(card)"
                  draggable="true"
                  @dragstart.self="onDragStart(card, statusKey, $event)"
                >
                  <v-tooltip :offset="1">
                    <template #activator="{ props }">
                      <v-card
                        class="task-card"
                        v-bind="props"
                        :class="{ 'preview-style': card.isPreview,
                        'selected-task': selectedCardId === card.cardId}"
                      >
                        <span>
                          {{ card.cardTitle }}
                        </span>
                        <div class="divider-line"></div>
                      <div v-for="(item, i) in card.cardData.filter(
                        item => item.isSelected == 1 && item.propertyType !== '8' &&item.propertyName !== 'ステータス' && item.dataValue !== '' && item.dataValue !== null && item.isDeleted !== 1)" 
                        :key="i" class="card-data" >
                        <span>{{ item.propertyName }} : {{ item.dataValue }}</span>
                      </div>
                      </v-card>
                    </template>
                    <span>
                          {{ card.cardTitle }}
                    </span>
                  </v-tooltip>
                  <v-menu
                    v-model="iconVisible"
                    :close-on-content-click="false"
                    :style="{
                      position: 'absolute',
                      top: `${contextMenuPosition.y}px`,
                      left: `${contextMenuPosition.x}px`,
                    }"
                    max-width="100px"
                    transition="slide-x-reverse-transition"
                  >
                    <v-btn
                      color="red"
                      icon="mdi-delete"
                      @click="handleDelete(this.selectedItem)"
                    >
                      <v-tooltip activator="parent" location="bottom"
                        >カード削除</v-tooltip
                      >
                      <v-icon> mdi-delete</v-icon>
                    </v-btn>
                  </v-menu>
                </div>
              </div>
              <!-- <div v-else>
                <p>このステータスにはカードがありません。</p>
              </div> -->
            </v-card-text>
          </v-card>
        </v-col>
      </div>
    </div>
    <v-dialog v-model="errorDialog" persistent max-width="290">
                <v-card>
                  <v-card-title class="headline">エラー</v-card-title>
                  <v-card-text> ステータス名を入力してください。 </v-card-text>
                  <v-card-actions>
                    <v-btn color="primary" text @click="errorDialog = false"
                      >閉じる</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>

    <!-- サイドバー -->
    <card-side-bar
      :cardStaffId="staffId"
      :selectedSideCard="selectedSideCard"
      :getProperties="newData"
      :isVisible="isSidebarVisible"
      @update:isVisible="handleSidebarVisibility"
      @update-task="updateCardInfo"
      @save-new-card="saveNewCard"
      @updateAllStaff="setSelectItems"
      :selectCardId="cardId"
      :newCardId="newCardId"
    />

    <!-- 新規カード作成ダイアログ -->
    <v-dialog v-model="isNewCardDialogVisible" max-width="500px">
      <v-card>
        <v-card-title class="headline">新規カード作成</v-card-title>
        <div v-if="selectedScreenName === '営業対象者画面'">
          <!-- 社員選択セレクトボックス-->
          <v-card-text>
            <v-autocomplete
              v-model="newCard.title"
              :items="allStaff.staffList"
              item-title="staffName"
              item-value="staffName"
              label="社員名を選択"
            />
          </v-card-text>
        </div>
        <div v-else>
          <v-card-text>
            <v-text-field
              label="カードタイトル"
              v-model="newCard.title"
              outlined
            ></v-text-field>
          </v-card-text>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeNewCardDialog">キャンセル</v-btn>
          <v-btn color="primary" @click="saveNewCardStatus()">保存</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import CardSideBar from "./CardSideBar.vue";
import taskCardApi from "@/api/card";
import cardApi from "@/api/card";
import cardSidebarApi from "@/api/cardSidebar";
import eventBus from "@/eventBus";

export default {
  name: "CardEdit",
  components: {
    CardSideBar,
  },
  props: {
    searchResult: {},
    tableId: {
      type: Number,
    },
    data: {
      type: Object,
    },
  },

  data() {
    return {
      previewCardMap: {}, // カラムのプレビューカード状態
      dragEnterDepth: {}, // カラムのdepth
      staffId: null,
      selectedStaffId: null,
      allStaffs: [],
      contextMenuVisible: false,
      rightClickPosition: { x: 0, y: 0 },
      selectedStatusKey: null,
      renameDialogVisible: false,
      newStatusName: "",
      confirmDeleteDialogVisible: false,
      statusDialog: false, // ダイアログの表示/非表示
      newStatusTitle: "", // 新しいステータス名
      statusList: [], // ステータスリスト
      localProperties: [],
      authUserId: null,
      sessionKey: "",
      errorMessage: "",
      propertyDialog: false,
      isSidebarVisible: false,
      selectedSideCard: {},
      boardProperties: [],
      cards: [],
      values: [],
      filtered: [],
      dataValues: [],
      localData: [],
      uniqueData: [], // uniqueDataを保持する
      uniqueStatus: [],
      isNewCardDialogVisible: false,
      newCard: {
        propertyId: null,
        title: "",
        status: "",
      },
      newCardId: null,
      statusOptions: [], // ステータスセレクトアイテム
      errorDialog: false,
      iconVisible: false,
      selectedItem: null,
      contextMenuPosition: { x: 0, y: 0 },
      newData: [],
      selectedScreenName: null,
      draggedCard: null,
      previousStatus: null,
      cardValueId: null,
      cardDataValue: "",
      cardData: {},
      selectedCardId : null,
      lastOpenCardId: null, 
    };
  },
  computed: {
    filteredStatus() {
      if (Array.isArray(this.uniqueStatus)) {
        return this.uniqueStatus.filter(
          (status) => status.propertyName === "ステータス"
        );
      }
      return [];
    },
    getUniqueData() {
      // uniqueDataを設定する処理
      if (this.filtered && Array.isArray(this.filtered)) {
        return [
          ...new Set(
            this.filtered.map((item) => item.selectionItem?.dataValue)
          ),
        ];
      }
      return [];
    },
  },
  watch: {
    searchResult: {
      handler() {
        this.loadTaskCards();
      },
    },

    selectedStaffId(newId) {
      const staff = this.allStaff.staffList.find(
        (item) => item.staffId === newId
      );
      if (staff) {
        this.newCard.title = staff.staffName;
      }
      this.staffId = newId;
    },
    // selectedSideCard: {
    //   handler() {
    //     console.log("watchSelectedCard", this.selectedSideCard);
    //   },
    //   deep: true,
    // },

    filtered(newValue) {
      if (Array.isArray(newValue)) {
        const dataValues = newValue
          .map((item) => item.selectionItem?.dataValue)
          .filter(Boolean);
        this.uniqueData = [...new Set(dataValues)];
      }
    },
    searchQuery(newQuery) {
      this.filteredCards = this.cards.filter(
        (card) =>
          card.cardTitle.includes(newQuery) ||
          card.propertyValue.some((prop) => prop.value.includes(newQuery))
      );
    },
    data: {
      deep: true,
      handler(newValue) {
        const actualData = newValue ? newValue : newValue?.data;
        this.newData = actualData;
      },
    },
    allStaff: {
      deep: true,
      handler(newValue) {
        this.setSelectItems(newValue);
      },
    },
    renameDialogVisible(newVal) {
      if (newVal === false) {
        this.newStatusName = null;
      }
    },
  },
  mounted() {
    const screenData = JSON.parse(sessionStorage.getItem("screenData"));
    this.selectedScreenName = screenData.screenName;
    this.$watch("data", this.$options.watch.data.handler, { immediate: true });
    this.boardProperties = this.newData;
    this.cards.forEach((card, index) => {
      card.propertyInfo = this.newData;
      card.propertyValue = card.propertyInfo.map((property) => {
        if (property.name === "ステータス") {
          return { name: "ステータス", value: property.options[0] };
        }
        return { name: property.name, value: null };
      });
      card.index = index;
    });
    console.log("更新後のcards:", this.cards);
  },
  async created() {
    await this.loadTaskCards();
  },
  methods: {
    handleSidebarVisibility(val) {
    this.isSidebarVisible = val;
    if (!val) {
      this.selectedCardId = null;
    }
    },
    handleDragEnter(statusKey) {
      if (this.draggedCard && this.previousStatus !== statusKey) {
        if (!this.dragEnterDepth[statusKey]) this.dragEnterDepth[statusKey] = 0;
        this.dragEnterDepth[statusKey]++;

        if (this.dragEnterDepth[statusKey] === 1) {
          const previewCard = {
            cardId: "preview",
            cardTitle: this.draggedCard.cardTitle,
            isPreview: true,
            isDeleted: 0,
          };
          this.removePreviewCard(statusKey);
          this.filteredStatus[statusKey].cards.push(previewCard);
          this.previewCardMap[statusKey] = previewCard;
        }
      }
    },
    handleDragLeave(statusKey) {
      if (this.draggedCard && this.previousStatus !== statusKey) {
        this.dragEnterDepth[statusKey]--;
        if (this.dragEnterDepth[statusKey] === 0) {
          this.removePreviewCard(statusKey);
        }
      }
    },
    removePreviewCard(statusKey) {
      const cards = this.filteredStatus[statusKey].cards;
      const index = cards.findIndex((c) => c.cardId === "preview");
      if (index !== -1) {
        cards.splice(index, 1);
      }
      delete this.previewCardMap[statusKey];
    },
    onDragOver(event) {
      event.dataTransfer.dropEffect = "move";
    },
    onDragStart(card, statusKey, event) {
      const statusObj = this.filteredStatus[statusKey];
      if (!statusObj || statusObj.propertyName !== "ステータス") {
        console.warn(
          "このステータスはドラッグ対象外です:",
          statusObj?.propertyName
        );
        return;
      }
      this.draggedCard = card;
      this.previousStatus = String(statusKey);
      console.log(
        "Drag Start - Current Card:",
        card,
        "Current StatusKey:",
        statusKey
      );
      this.dragEnterDepth = {};
      this.previewCardMap = {};
      event.dataTransfer.effectAllowed = "move";
    },
    async onDrop(targetStatusKey, newStatus) {
      this.removePreviewCard(targetStatusKey);
      if (!this.draggedCard) {
        console.error(
          "ドロップしたカードがNULL又はUndefinedです",
          this.draggedCard
        );
        return;
      }
      const sourceStatusKey = this.previousStatus;
      const sourceCards = this.filteredStatus[sourceStatusKey]?.cards || [];
      const sourceIndex = sourceCards.findIndex(
        (card) => String(card.cardId) === String(this.draggedCard.cardId)
      );
      if (sourceIndex === -1) {
        console.error(
          "ステータスが見つかりませんでした",
          sourceIndex,
          sourceCards
        );
        return;
      }

      const removedCard = sourceCards.splice(sourceIndex, 1)[0];
      this.filteredStatus[targetStatusKey].cards.push(removedCard);

      const authUserId = localStorage.getItem("authUserId");
      const sessionKey = localStorage.getItem("sessionKey");
      const staffName = localStorage.getItem("staffName");

      this.cardValueId = removedCard.valueId;
      this.cardDataValue = newStatus.dataValue;

      await cardApi.updateCardStatus(
        authUserId,
        sessionKey,
        staffName,
        this.cardValueId,
        this.cardDataValue
      );
      if(this.selectedCardId === this.draggedCard.cardId){
        await eventBus.emit("card-status-updated", this.draggedCard.cardId);
      }
      this.draggedCard = null;
      this.previousStatus = null;
    },

    rightClickMenu(event, statusName, statusKey) {
      this.contextMenuVisible = true;

      this.rightClickPosition = { x: event.clientX, y: event.clientY };
      this.selectedStatusName = statusName;
      this.selectedStatusKey = statusKey;
    },
    closeContextMenu() {
      this.contextMenuVisible = false;
    },
    async deleteData() {
      const statusData = this.uniqueStatus?.[this.selectedStatusKey];

      if (!statusData || !Array.isArray(statusData.cards)) {
        alert("削除するデータが存在しません。");
        return;
      }

      const valueIds = statusData.cards
        .filter((item) => item.isDeleted === 0)
        .map((item) => item.valueId);

      
      const propertyId = statusData.propertyId;
      const propertyName = statusData.propertyName;
      const dataValue = statusData.dataValue;

      this.authUserId = localStorage.getItem("authUserId");
      this.sessionKey = localStorage.getItem("sessionKey");
      const staffName = localStorage.getItem("staffName");

      await cardApi
        .deleteData(
          valueIds,
          propertyId,
          propertyName,
          dataValue,
          this.authUserId,
          this.sessionKey,
          staffName
        )
        .then((response) => {
          if (response.status === 200) {
            alert("プロパティの削除が正常に更新されました。");
            window.location.reload();
          } else {
            alert("プロパティ名の更新に失敗しました。");
          }
        })
        .catch((err) => {
          console.error("データ削除中にエラーが発生しました。", err);
        });
    },
    selectionDataEdit() {
      if (!this.newStatusName || !this.newStatusName.trim()) {
        this.errorDialog = true;
        return;
      }
      const statusData = this.uniqueStatus[this.selectedStatusKey];
      const dataValue = statusData.dataValue;
      const newName = this.newStatusName;
      this.authUserId = localStorage.getItem("authUserId");
      this.sessionKey = localStorage.getItem("sessionKey");
      const staffName = localStorage.getItem("staffName");
      cardApi
        .selectionDataEdit(
          dataValue,
          newName,
          this.authUserId,
          this.sessionKey,
          staffName
        )
        .then((response) => {
          if (response.status === 200) {
        alert("プロパティ名が正常に更新されました。");
        window.location.reload();
      }
    })
    .catch((err) => {
      if (err.status === 409) {
        alert("既に存在するステータス名です。");
      } else if (err.status === 401) {
        alert(err.message || "認証エラーが発生しました。");
      } else {
        alert("プロパティ名の更新に失敗しました。");
      }
      console.error("selectionDataEdit - Error:", err);
    });
    },
    openRenameDialog(statusName, statusKey) {
      this.contextMenuVisible = true;
      this.selectedStatusName = statusName;
      this.selectedStatusKey = statusKey;
      this.renameDialogVisible = true;
      this.closeContextMenu();
    },
    openDeleteDialog(statusName, statusKey) {
      this.contextMenuVisible = true;
      this.selectedStatusName = statusName;
      this.selectedStatusKey = statusKey;
      if (this.uniqueStatus.length <= 1) {
        alert(
          "ステータスが1個以下の時は削除できません。\n最低1つのステータスは保持する必要があります。"
        );
      } else {
        this.confirmDeleteDialogVisible = true;
      }
      this.closeContextMenu();
    },
    showContextMenu(event, card) {
      this.contextMenuPosition = { x: event.clientX, y: event.clientY };
      this.iconVisible = true;
      this.selectedItem = card;

      const menuWidth = 200;
      const menuHeight = 150;
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;

      if (this.contextMenuPosition.x + menuWidth > windowWidth) {
        this.contextMenuPosition.x = windowWidth - menuWidth;
      }
      if (this.contextMenuPosition.y + menuHeight > windowHeight) {
        this.contextMenuPosition.y = windowHeight - menuHeight;
      }
    },
    async handleDelete(item) {
      try {
        const deletingCardId = item.cardId;
        this.authUserId = localStorage.getItem("authUserId");
        this.sessionKey = localStorage.getItem("sessionKey");
        const staffName = localStorage.getItem("staffName");
        await taskCardApi.deleteCard(
          this.authUserId,
          this.sessionKey,
          item.cardId,
          staffName
        );
        if (this.lastOpenCardId === deletingCardId) {
          this.closeSidebar()
          this.lastOpenCardId = null;
        }
        this.iconVisible = false;
        await this.$emit("triggerSearch");
        this.loadTaskCards();
        this.$emit("refreshProperties");
      } catch (error) {
        console.log("handleDelete - Error:", error.message);
      }
    },
    openNewCardDialog(propertyId, statusValue) {
      console.log(
        "openNewCardDialog - Opening new card dialog with propertyId:",
        propertyId,
        "statusValue:",
        statusValue
      );
      this.newCard.propertyId = propertyId;
      this.newCard.status = statusValue;
      this.isNewCardDialogVisible = true;
    },
    closeNewCardDialog() {
      this.isNewCardDialogVisible = false;
      this.newCard = { propertyId: null, title: "", status: "" };
    },
    saveNewCardStatus() {
      console.log(
        "saveNewCardStatus - Saving new card status with title: ",
        this.newCard.title,
        "status: ",
        this.newCard.status
      );
      if (this.newCard.title && this.newCard.status) {
        this.authUserId = localStorage.getItem("authUserId");
        this.sessionKey = localStorage.getItem("sessionKey");
        this.addNewCard(
          this.newCard.propertyId,
          this.newCard.status,
          this.newCard.title
        );
        this.closeNewCardDialog();
        this.$emit("refreshProperties");
      } else {
        console.error(
          "saveNewCardStatus - Title or status not found",
          this.newCard
        );
      }
    },
    async addNewCard(propertyId, statusKey, cardTitle) {
      try {
        const staffName = localStorage.getItem("staffName");
        console.log(
          "カード追加propertyId:",
          propertyId,
          "statusKey:",
          statusKey,
          "cardTitle:",
          cardTitle
        );
        const [response] = await taskCardApi.addNewCard(
          this.authUserId,
          this.sessionKey,
          this.tableId,
          propertyId,
          statusKey,
          cardTitle,
          staffName
        );
        await this.$emit("triggerSearch");
        this.newCardId = response.cardId;
        const CardData = {
          cardId: this.newCardId,
          title: '',
          cardTitle: cardTitle,
          propertyInfo: [],
          propertyValue: []
        };
        this.openSidebar(CardData);
        this.loadTaskCards();

        console.log("addNewCard - 成功");
      } catch (error) {
        console.error("addNewCard - 失敗:", error.message);
      }
    },
    async loadTaskCards() {
      try {
        this.uniqueStatus = await this.searchResult;
        console.log(
          this.searchResult,
          "loadTaskCards Called",
          this.uniqueStatus
        );
      } catch (error) {
        this.errorMessage =
          error.message || "タスクカードの読み込みに失敗しました";
        console.log(error.message);
      }
    },
    filteredCards(status) {
      return this.cards.filter((card) => card.status === status);
    },
    async openSidebar(card) {
      this.selectedCardId = card.cardId;
      this.lastOpenCardId = card.cardId;
      let selectedSideCard = card
        ? { ...card } // オブジェクトをコピーして変更を検知
        : { id: null, title: '', cardTitle: card.cardTitle, propertyInfo: [], propertyValue: [] };

      this.isSidebarVisible = true;
      setTimeout(() => {
            if(!this.isSidebarVisible) this.isSidebarVisible = true;
          }, 100);

      // 新しいオブジェクトを割り当ててVueが変更を検知できるようにする
      this.selectedSideCard = { ...selectedSideCard };

      // watchを使用せずに、直接データを更新
      if (selectedSideCard.id) {
        await this.fetchCardData(selectedSideCard.id);
      }
    },
    closeSidebar() {
      this.isSidebarVisible = false;
      this.selectedCardId = null;
    },
    openAddStatusDialog() {
      this.statusDialog = true;
    },
    async saveNewStatus(newStatusTitle) {
      const tableId = sessionStorage.getItem("tableId");
      console.log(
        "saveNewStatus: ",
        "Saving new status with title:",
        newStatusTitle
      );
      if (newStatusTitle.trim()) {
        const staffName = localStorage.getItem("staffName");
        this.newStatusTitle = newStatusTitle.trim();
        this.statusDialog = false;
        const authUserId = localStorage.getItem("authUserId");
        const sessionKey = localStorage.getItem("sessionKey");
        await cardSidebarApi.addStatus(
          tableId,
          this.newStatusTitle,
          staffName,
          authUserId,
          sessionKey
        );
        await this.$emit("triggerSearch");
        await this.loadTaskCards();
      } else {
        this.errorDialog = true;
        console.log("saveNewStatus - 失敗: Title is empty");
      }
    },
    setSelectItems(allStaff) {
      console.log("全社員もらったからセレクトボックスに使え", allStaff);
      this.allStaff = allStaff;
    },
    saveNewCard(newCard) {
      console.log("saveNewCard:", newCard);
      this.cards.push(newCard);
      this.closeSidebar();
    },
    updateCardInfo(updatedTask) {
      console.log("updateCardInfo:", updatedTask);
      const cardIndex = this.cards.findIndex(
        (card) => card === this.selectedCard
      );
      if (cardIndex !== -1) {
        this.cards[cardIndex] = { ...this.selectedCard, ...updatedTask };
        console.log("updateCardInfo:", this.cards[cardIndex]);
      } else {
        console.log("updateCardInfo - Card not found");
      }
      this.$emit("triggerSearch");
      this.loadTaskCards();
      this.closeSidebar();
    },
  },
};
</script>


<style scoped>
/* 全体背景（青系のグラデーション） */
body {
  background: linear-gradient(45deg, #3f51b5, #2196f3);
  /* 青とライトブルーのグラデーション */
  background-size: cover;
  color: rgb(255, 255, 255);
  font-family: "Arial", sans-serif;
  margin: 0;
  padding: 0;
}

/* ステータス名部分（青のグラデーション） */
.status-title {
  background: rgb(58, 58, 255);
  /* ライトブルーからダークブルーのグラデーション */
  color: white;
  padding: 5px;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  border-radius: 10px;
  text-transform: uppercase;
  margin: 10px 15px 10px 15px;
}

.status-add {
  background: linear-gradient(135deg, #000000, #000000);
  /* ライトブルーからダークブルーのグラデーション */
  color: white;
  text-align: center;
  font-size: 22px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  font-weight: 700;
  text-transform: uppercase;
  position: fixed;
  bottom: 40px;
  right: 40px;
  z-index: 1000;
}

.add-card {
  background: linear-gradient(135deg, #136fc0, #64b5f6);
  /* ライトブルーからダークブルーのグラデーション */
  color: white;
  padding: 15px;
  text-align: center;
  font-size: 18px;
  border-radius: 10px;
  font-weight: 700;
  text-transform: uppercase;
  margin-top: 10px;
}

/* 新規カード追加ボタン */
.new-card-btn {
  background: white;
  /* ダークブルー */
  color: blue;
  border-radius: 10px;
  font-size: 14px;
  border: 1px solid blue;
  margin-top: 10px;
}

/* カードのスタイル */
.task-card {
  font-size: 16px;
  background-color: rgb(255, 255, 255);
  border-radius: 10px;
  margin-bottom: 15px;
  padding: 10px;
  text-align: center;
  text-overflow: ellipsis;
  /* transition: transform 0.3s ease, box-shadow 0.3s ease; */
  cursor: pointer;
  border: 1px solid #cccccc;
  /* フォントサイズを小さめに設定 */
}

.task-card:hover {
  background-color: #f2f2f2;
  /* transform: scale(1.05); */
  /* ホバー時にフォントサイズを少し大きく
  transition: background-color 0.3s ease, transform 0.3s ease; */
}

.card-title {
  background: linear-gradient(45deg, #213af3, #64b5f6);
  /* 青と薄い青のグラデーション */
  color: white;
  padding: 15px;
  font-size: 18px;
  font-weight: 600;
  border-radius: 10px;
  text-transform: uppercase;
}

.card-title:hover {
  background: linear-gradient(45deg, #1e88e5, #4caf50);
  /* ホバー時に少し異なるグラデーション */
}

.status-row {
  display: flex;
}

.load-cards-btn:hover {
  background-color: #1976d2;
  /* 濃い青 */
  transform: scale(1.05);
  /* 少し拡大する */
}

/* ステータスエリア全体の背景色 */
.status-column {
  border-radius: 10px;
  border: 1px solid #cccccc;
}

/* ステータスカラム（サイズ調整） */
.status-column {
  max-width: 300px;
  /* ステータスカラムの最大幅を調整 */
  width: 100%;
}

.title-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 2px;
}

/* (：)ボタンを右に設定 */
.status-menu-btn {
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  color: white;
}

.status-menu-btn:hover {
  background-color: #5b5bff;
}

.preview-style {
  opacity: 0.6;
  border: 2px dashed #2196f3;
  background-color: #e3f2fd;
  font-style: italic;
}

.card-data {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
}

.divider-line {
  border-top: 1px solid #ccc;
  margin: 4px 0;
}

.task-card.selected-task {
  background: rgb(58, 58, 255);
  color: white;
}

</style>
